import axios from "axios";

let willLogout = false;

export default () => {
  const responseSuccessHandler = (response) => {
    return response;
  };

  const responseErrorHandler = (error) => {
    if ([
      401,
      // 403,
      // 502,
    ].includes(error.response.status) && !willLogout) {
      willLogout = true;
      // Flagged so the Logout event can tell a forced sign-out apart from one
      // the user asked for.
      document.location.href = "/sign-out?reason=session_expired";
    }

    return Promise.reject(error);
  };

  axios.interceptors.response.use(
    (response) => responseSuccessHandler(response),
    (error) => responseErrorHandler(error)
  );
};
